<template>
  <div class="login-form _flxccc">
    <header class="content-heading">
      <h1 class="txt-header">Interactive Video Editor</h1>
    </header>
    <section class="content-main">
      <div v-if="!forgotPassword" class="login-view__load _flxcs">
          <h3 class="txt-heading">Login</h3>
          <label class="txt-label"  for="email" >E-Mail*</label>
          <input name="email" v-validate="'required|email'" autocomplete="true" type="text" v-model="email" />
          <span class="invalid">{{ errors.first('email') }}</span>
          <label class="txt-label" for="password" >Password*</label>
          <input name="password" v-validate="'required'" type="password" autocomplete="current-password" @keydown.enter="login()" v-model="password" />
          <span class="invalid">{{ errors.first('password') }}</span>
          <span class="failed" v-if="loginFailed">Your email or password was incorrect. Please try again.</span>
          <div class="button-div">
            <a class="forgotPassword" @click="forgotPassword=true">Forgot Password?</a>
            <button title="Login" class="action-button" @click="login()">Login</button>
          </div>
        </div>
        <div v-if="forgotPassword" class="login-view__load _flxcs">
          <h3 class="txt-heading">Reset password</h3>
          <span class="description">Please enter your email address to request a password reset.</span>
          <label class="txt-label" name='sendEmail' for="sendEmail" >E-Mail*</label>
          <input name="sendEmail" v-validate="'required|email'" autocomplete="true" type="text" v-model="sendEmail" />
          <span class="invalid">{{ errors.first('sendEmail') }}</span>
          <div class="button-div">
            <button title="Login" class="button" @click="send()">Send</button>
            <button title="Close" class="button" @click="forgotPassword=false">Close</button>
          </div>
        </div>
    </section>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'login',
  data: () => ({
    email: '',
    password: '',
    loginFailed: false,
    forgotPassword: false,
    sendEmail: ''
  }),
  computed: {
    ...mapGetters(['isAuthenticated', 'user'])
  },
  created() {
    if (this.isAuthenticated) {
      this.$router.push('project')
    }
  },
  methods: {
    ...mapActions(['loginUser', 'resetPassword', 'notify']),
    login: function() {
      this.$validator.validate().then(valid => {
        if (valid) {
          const that = this
          this.loginUser({email: this.email, password: this.password}).then(() => {
            that.$router.push('project')
          }, () => {
            that.loginFailed = true;
          })
        }
      })
    },
    send: function() {
      this.$validator.validate().then(valid => {
        if (valid) {
          this.resetPassword(this.sendEmail).then(() => {
            this.notify({title: 'Reset password', text: 'You have received a mail', sticky: 2000})
            this.forgotPassword = false;
          })
        }
      })
    }
  }
}
</script>
